module.exports = __webpack_public_path__ + "static/img/zhengshu2.97f41ad6.webp";